import { useReduxState } from 'hooks';
import { Link } from 'components/common';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  children: React.ReactNode;
  href?: string;
  icon: IconProp;
  innerStyle?: React.CSSProperties;
}

const CardExtension = ({ children, href, icon, innerStyle }: Props) => {
  const { theme } = useReduxState();

  const handleClick = (ev: React.MouseEvent) => {
    ev.stopPropagation();
  };

  const Wrapper = ({ children }) =>
    href ? (
      <Link href={href} onClick={handleClick}>
        {children}
      </Link>
    ) : (
      children
    );

  return (
    <div className="extension">
      <Wrapper>
        <div className="inner" style={innerStyle}>
          <div className="icon">
            <Icon icon={icon} />
          </div>
          <div className="content">{children}</div>
        </div>
      </Wrapper>

      <style jsx>{`
        .inner {
          align-items: flex-start;
          border-top: 1px solid ${theme.lightGrey};
          color: ${theme.textColor};
          display: flex;
          font-size: 1.4rem;
          font-weight: 600;
          gap: 7px;
          justify-content: space-between;
          padding: 7px 15px 8px;
          text-decoration: none;
        }
        .icon {
          font-size: 1.2rem;
          position: relative;
          top: 1px;
        }
        .content {
          display: flex;
          flex-grow: 1;
          gap: 10px;
        }
      `}</style>
    </div>
  );
};

export default CardExtension;
